export enum MerchantEnum {
    Jiffy = 'Jiffy',
    SkyMark = 'SkyMart'
}